module.exports = __webpack_public_path__ + "img/4219f8ee8130bc9c9a7156c1b7136a21.4219f8ee.png";